import React, { FunctionComponent } from 'react';

import { Experiments } from '../../constants/experiments';
import { useDonationAmount } from '../../hooks';
import { DonateButton } from '../DonateButton/DonateButton';
import { DonationAmountSelector } from '../DonationAmountSelector/DonationAmountSelector';
import { Share } from '../SocialButtons/Share';

const FundraisingCTA: FunctionComponent = () => {
  // AB test: starting_donation_on_frp_with_amount_page
  // Can be removed when experiment has ended
  const { showDonationAmountVariant } = useDonationAmount();
  return (
    <>
      {/*  AB test: starting_donation_on_frp_with_amount_page
           Can be removed when experiment has ended */}
      {showDonationAmountVariant === 'B' && <DonationAmountSelector />}
      <DonateButton
        key="donateButton"
        className="jg-space-mrsm jg-space-mrn@lg jg-space-mbsm"
        trackingDataPageSection="FundraisingCTA"
        experiments={[
          // B2C_041 - Donation Prompts Part 2
          // Remove the experiment slug from the list below when removing this experiment
          Experiments.b2c_041_fundraising_page_donation_prompts_2,
          // B2C_045 - Donate button color
          // Can be removed when experiment has ended
          Experiments.b2c_045_donate_button_color,
          // B2C_029 - First to donate
          // Can be removed when experiment has ended
          Experiments.b2c_029_first_to_donate,
          // B2C_040 - Proposition Bar
          // Remove this experiment when complete
          Experiments.b2c_040_frp_trust_proposition_bar,
          // B2C_044 - donate to yourself
          // Remove this experiment when complete
          Experiments.b2c_044_donate_to_yourself,
          // B2C_048 - show hide fitness data
          // Can be removed when experiment has ended
          // or added as a non experiment test if successful
          Experiments.b2c_048_show_hide_fitness_data,
        ]}
        successType="StaticDonateButtonClick"
      />
      <Share successType="StaticShareButtonClick" />
    </>
  );
};

export default FundraisingCTA;
